import { create } from "zustand"
import axios from "@/utils/axios"

export interface IWishList {
  pdt_id: string
  variant_id?: string
  flag?:boolean
}

interface IObj {
    [key: string]: any
}
type States = {
  wishList: IWishList[]
  profileWishLists: IObj[]
}

interface IResponse {
  status: boolean
  data?: any
  message?: string
  error?: string
}

type Actions = {
  fetchWishList: (items?: IWishList[]) => Promise<IResponse>
  updateWishList: (doc: IWishList, isAuth?: boolean) => Promise<IResponse>
  updateUserWishList: (doc: { items: IWishList[] }) => Promise<IResponse>
  setWishList: (items: IWishList[], isAuth?: boolean) => void
}

function parseWishList(str: string): IWishList[] {
  try {
    return JSON.parse(str)
  } catch {
    return []
  }
}

const useWishListStore = create<States & Actions>((set, get) => ({
  wishList:
    typeof window !== "undefined" && localStorage.getItem("wishlist")
      ? parseWishList(localStorage.getItem("wishlist") || "[]")
      : [],
    profileWishLists:[],

  setWishList: (items: IWishList[], isAuth: boolean = false) => {
    set({ wishList: items })
    if (typeof window !== "undefined") {
      if (isAuth) localStorage.removeItem("wishlist")
      else localStorage.setItem("wishlist", JSON.stringify(items))
    }
  },

  fetchWishList: async (items?: IWishList[]) => {
    try {
      const result = await axios.get(
        process.env.NEXT_PUBLIC_PRODUCT_SERVICE + "/user/wishlist/list"
      )
      if (result?.data?.status) {
        get().setWishList(result.data?.data?.list || [], true)
         set({ profileWishLists: result.data?.data?.list })
        return { status: true, data: result.data?.data }
      }
      return { status: false, error: result.data?.error || "Something went wrong" }
    } catch (error: any) {
      return { status: false, error: error?.message || "Something went wrong" }
    }
  },

  updateWishList: async (doc: IWishList,  isAuth?: boolean) => {
    try {
      if (isAuth) {
        const result = await axios.post(
          process.env.NEXT_PUBLIC_PRODUCT_SERVICE + "/user/wishlist/update",
          {
            PRODUCT_ID: doc.pdt_id,
            VARIANT_ID: doc.variant_id,
            FLAG: doc.flag
          }
        )        
        if (result?.data?.status) {
          await get().fetchWishList()
          return { status: true, message: "Wishlist updated" }
        }
        return { status: false, error: result.data?.message || "Something went wrong" }
      } else {
        let list = [...get().wishList]
        const index = list.findIndex(
          i => i.pdt_id === doc.pdt_id
        )

        if (doc.flag) {
          if (index === -1) list.push(doc)
        } else {
          if (index !== -1) list = list.filter(i => i.pdt_id !== doc.pdt_id)
        }

        get().setWishList([...list])
        return { status: true, message: "Wishlist updated" }
      }
    } catch (error: any) {
      return { status: false, error: error?.message || "Something went wrong" }
    }
  },

  // 🔑 Just like syncUserCart → syncUserWishList inside store
  updateUserWishList: async (doc: { items: IWishList[] }) => {
    try {
      for (const item of doc.items) {
        await axios.post(
          process.env.NEXT_PUBLIC_PRODUCT_SERVICE + "/user/wishlist/update",
          {
            PRODUCT_ID: item.pdt_id,
            VARIANT_ID: item.variant_id,
            FLAG: true
          }
        )
      }

      // reload wishlist
      const result = await axios.get(
        process.env.NEXT_PUBLIC_PRODUCT_SERVICE + "/user/wishlist/list"
      )
      if (result?.data?.status) {
        get().setWishList(result.data?.data?.list || [], true)
        return { status: true, data: result.data?.data }
      }
      return { status: false, message: "Something went wrong" }
    } catch (error: any) {
      return { status: false, message: error?.message || "Something went wrong" }
    }
  }
}))

export default useWishListStore


// import axios from "@/utils/axios"
// import { create } from "zustand"

// type States = {
//     wishLists: IObj[];
// }
// type Actions = {
//     wishListDetails: () => Promise<IResponse>//get request
//     updateWishList: (doc: IObj) => Promise<IResponse>
//     // setCart: (items: IWishList[], isAuth?: boolean) => void
//     // updateCart: (item: IWishList, mxq?: number, isAuth?: boolean) => Promise<IResponse>
//     // updateUserCart: (doc: { items: IWishList[] }) => Promise<IResponse>
// }

// interface IObj {
//     [key: string]: any
// }

// interface IResponse {
//     status: boolean
//     data?: any
//     error?: string
//     message?: string
// }
// export interface IWishList {
//     pdt_id: string
// }


// const useWishListStore = create<States & Actions>((set) => ({
//     wishLists: [],
//     wishListDetails: async () => {
//         try {
//             const result = await axios.get(process.env.NEXT_PUBLIC_PRODUCT_SERVICE + "/user/wishlist/list");
//             if (result?.data?.status) {
//                 set({ wishLists: result.data?.data?.list })
//                 return { status: true, data: result.data?.data };
//             } else {
//                 return { status: false, error: result.data?.error || "Something went wrong" };
//             }
//         } catch (error: any) {
//             return { status: false, error: error?.message || "Something went wrong" };
//         }
//     },
//     updateWishList: async (doc: IObj) => {
//         try {
//             const result = await axios.post(process.env.NEXT_PUBLIC_PRODUCT_SERVICE + "/operations/wishlist/update", doc);
//             if (result?.data?.status) {
//                 set({ wishLists: result.data?.data?.list })
//                 return { status: true, data: result.data?.data };
//             } else {
//                 return { status: false, error: result.data?.error || "Something went wrong" };
//             }
//         } catch (error: any) {
//             return { status: false, error: error?.message || "Something went wrong" };
//         }
//     }
// }))
// export default useWishListStore
